import React, { useEffect, useRef, useState } from 'react';

export const Brands = ({ data }) => {
  const [visibleBrands, setVisibleBrands] = useState([]);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          data.forEach((_, index) => {
            setTimeout(() => {
              setVisibleBrands(prev => [...prev, index]);
            }, index * 150);
          });
        }
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, [data]);

  // Duplicate the list so the marquee can loop seamlessly
  const loop = [...data, ...data, ...data];

  return (
    <section ref={sectionRef} className="brands-section" data-testid="brands-section">
      <div className="container">
        <h2 className="section-title">Our Brands</h2>

        <div className="brands-grid">
          {data.map((brand, index) => (
            <div
              key={index}
              className={`brand-card ${visibleBrands.includes(index) ? 'visible' : ''}`}
            >
              <div className="brand-image-wrapper">
                <img src={brand.image} alt={brand.name} className="brand-image" />
              </div>
              <p className="brand-description">{brand.description}</p>
              <p className="brand-country-tag">{brand.country}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="brands-marquee" data-testid="brands-marquee">
        <div className="brands-marquee-track">
          {loop.map((brand, index) => (
            <div
              key={`${brand.slug}-${index}`}
              className={`brand-strip-item ${brand.slug === 'north-bridge' ? 'is-northbridge' : ''}`}
              data-testid={`brand-strip-${brand.slug}`}
            >
              <img
                src={brand.image}
                alt={brand.name}
                className="brand-strip-image"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
